<template>
  <div ref="address-details" class="addressDetails">
    <div class="addressDetails__block addressDetails__block--summary">
      <address-details-summary :address="address.address" :total-count="address.totalCount" />
    </div>
    <div class="addressDetails__block addressDetails__block--stats">
      <address-details-stats :stats="address" />
    </div>
    <div class="addressDetails__block addressDetails__block--qr">
      <address-details-qr :data="address.address" />
    </div>
  </div>
</template>

<script>
import AddressDetailsSummary from './components/AddressDetailsSummary/index'
import AddressDetailsStats from './components/AddressDetailsStats'
import AddressDetailsQr from './components/AddressDetailsQr'

export default {
  name: 'AddressDetails',
  components: { AddressDetailsQr, AddressDetailsStats, AddressDetailsSummary },
  props: {
    address: {
      type: Object,
      required: true,
    },
  },
  emits: ['is-show'],
  mounted() {
    const intersectionObserver = new IntersectionObserver(entries => {
      if (entries[0].intersectionRatio <= 0) this.$emit('is-show', false)
      else this.$emit('is-show', true)
    })
    intersectionObserver.observe(this.$refs['address-details'])
  },
}
</script>

<style lang="scss" scoped>
.addressDetails {
  border: $border;
  display: grid;
  grid-gap: 32px;
  /* stylelint-disable-next-line order/properties-alphabetical-order */
  gap: 32px;
  padding: 16px;

  @media (min-width: $breakpoint-md) {
    grid-gap: 32px 16px;
    /* stylelint-disable-next-line order/properties-alphabetical-order */
    gap: 32px 16px;
    grid-template-columns: repeat(12, 1fr);
  }

  @media (min-width: $breakpoint-lg) {
    grid-gap: 32px;
    /* stylelint-disable-next-line order/properties-alphabetical-order */
    gap: 32px;
  }

  &__block {
    &--summary {
      @media (min-width: $breakpoint-md) {
        grid-column: 1 / 7;
        grid-row: span 2;
      }
    }

    &--stats {
      @media (min-width: $breakpoint-md) {
        grid-column: 7 / 13;
      }

      @media (min-width: $breakpoint-lg) {
        grid-column: 7/12;
      }
    }

    &--qr {
      margin: 0 auto;
      width: 224px;

      @media (min-width: $breakpoint-md) {
        grid-column: 7 / 13;
      }

      @media (min-width: $breakpoint-lg) {
        grid-column: auto;
      }

      @media (min-width: $breakpoint-xl) {
        width: 352px;
      }
    }
  }
}
</style>
